function e() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
export {
  e as isBodyOverflowing
};
//# sourceMappingURL=util.mjs.map
